import { colors } from '../../colors';
var input = {
  textColor: colors.graphite
};
export default input;